export default "__VITE_ASSET__DOz4NNMB__"